// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/vertical-scroller/vertical-scroller.component.scss
// module id = 576
// module chunks = 0